module.exports = __webpack_public_path__ + "img/tg.c50f3c5a.svg";